import React from 'react';
import { Box, Typography } from '@mui/material';
import { PREMIUM_FEATURES_COLUMN3 } from '../data/pricingContent';
import planningIcon from '../../../../assets/pricing/planning.svg';
import chatIcon from '../../../../assets/pricing/chat.svg';
import myFiles from '../../../../assets/pricing/myfiles.svg';
import inventoryIcon from '../../../../assets/pricing/inventory.svg';
import formsIcon from '../../../../assets/pricing/forms.svg';
import reportIcon from '../../../../assets/pricing/report.svg';
import businessIcon from '../../../../assets/pricing/buisness.svg';
import petIcon from '../../../../assets/pricing/pet.svg';

const FEATURE_ICONS = {
  plan: planningIcon,
  chat: chatIcon,
  files: myFiles,
  property: inventoryIcon,
  damage: formsIcon,
  structural: reportIcon,
  business: businessIcon,
  pet: petIcon,
};

const PremiumFeaturesColumn = () => (
  <Box
    sx={{
      border: '1px solid #EAEAEA',
      borderRadius: 3,
      boxShadow: '0px 1px 20px #00000029',
      p: 2,
      backgroundColor: '#FFFFFF',
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
    }}
  >
    <Box sx={{ textAlign: 'center', borderBottom: '1px solid #D8D8D8' }}>
      <Typography sx={{ fontSize: { xs: 19, lg: 20 }, fontWeight: 700, color: '#1C2333', mb: 0.3 }}>
        Everything you need. All in one place.
      </Typography>
      <Typography sx={{ fontSize: 11, fontWeight: 700, letterSpacing: 1, color: '#D13C3C', pb: 2 }}>
        YOUR PREMIUM MEMBERSHIP INCLUDES
      </Typography>
    </Box>

    <Box sx={{ mt: 2.5, display: 'flex', flexDirection: 'column', gap: 1.25 }}>
      {PREMIUM_FEATURES_COLUMN3.map((feature) => (
        <Box
          key={feature.title}
          sx={{
            display: 'flex',
            alignItems: 'flex-start',
            gap: 1.25,
            border: '1px solid #d8d8d8',
            borderRadius: '12px',
            p: 1.25,
          }}
        >
          <Box
            sx={{
              width: '50px',
              height: '50px',
              backgroundColor: '#FFF0F0',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
              borderRadius: '50px',
            }}
          >
            <Box component="img" src={FEATURE_ICONS[feature.icon]} alt="" />
          </Box>
          <Box sx={{ minWidth: 0 }}>
            <Typography sx={{ fontSize: 14, fontWeight: 700, color: '#202020' }}>
              {feature.title}
            </Typography>
            <Typography sx={{ fontSize: 12.5, color: '#5B6270', mt: 0.25, lineHeight: 1.5 }}>
              {feature.description}
            </Typography>
          </Box>
        </Box>
      ))}
    </Box>

    <Box
      sx={{
        mt: 'auto',
        borderRadius: 2,
        background: 'linear-gradient(135deg, #1a3763 0%, #d13c3c 100%)',
        color: '#fff',
        textAlign: 'center',
        py: 1.5,
        px: 1,
      }}
    >
      <Typography sx={{ fontSize: '14px', fontWeight: 700 }}>
        One Family. One Plan. One MYREDFOLDER®.
      </Typography>
      <Typography sx={{ fontSize: 11, opacity: 1, mt: 0.5, mb: 0.5 }}>
        Peace of mind today. Protection tomorrow.
      </Typography>
    </Box>
  </Box>
);

export default PremiumFeaturesColumn;
